import { createContext } from "react";

const RqContext = createContext();

export default RqContext;
